module.exports = __webpack_public_path__ + "static/media/img_jerusalen.c273b017.jpg";